import { $$, up } from './utilities/QuerySelectors.js';
import { deepSet } from './utilities/Objects.js';
import { clickToggle } from './utilities/clickToggle.js';
import { loadAsync as loadAsyncJs } from './utilities/addJS.js';
import { addTwiterHandle, addImageClass as addAuthorImageClass } from './components/single/MetaBoxSocial.js';
import { init as initEcap } from './components/ecap/init.js';
import { init as initFinancial } from './components/financial/init.js';
import { init as initCommerce } from './components/commerce/init.js';
import { MultiAccordion } from './components/reusable/accordions/MultiAccordion.js';
import { SingleAccordion } from './components/reusable/accordions/SingleAccordion.js';
import { init as initPagination } from './components/reusable/Pagination.js';
import { init as initFoundation } from './components/reusable/Foundation.js';
import { init as initFlipClock } from './components/reusable/FlipClock.js';
import { initFreeArticleNotice } from './components/article/free-article-notice.js';
import { ServicesTabs } from './components/home/ServicesTabs.js';
import { AuthorBio } from './components/single/AuthorBio.js';
import { initEvergreen } from './components/single/Evergreen.js';
import { Pagination as ArchivePagination } from './components/archive/Pagination.js';
import { Navigation } from './components/global/Navigation.js';
import { ScrollUpButton } from './components/global/ScrollUpButton.js';
import { init as initSearch } from './components/global/Search.js';
import { FOOL_GLOBALS, isTrue } from './utilities/WindowGlobals.js';
import { Tabs } from './components/global/Tabs';

deepSet(window, 'process.env.NODE_ENV', 'production');
deepSet(window, 'process.NODE_ENV', 'production');

Object.defineProperty(HTMLElement.prototype, '$$', {
    value: function (selector) {
        return $$(selector, this);
    },
});

document.addEventListener('DOMContentLoaded', () => {
    const bodyHasClass = (s) => document.body.classList.contains(s);

    $$('.toggler').forEach((toggler) => clickToggle(toggler));

    addTwiterHandle();
    addAuthorImageClass();

    const nav = new Navigation();
    if (bodyHasClass('no-megamenu')) {
        nav.initDesktop();
        nav.initMobile();
        nav.initFooter();
    }

    $$('.js-badger-accordion').forEach((n) => new MultiAccordion(n).init());

    if (bodyHasClass('home')) {
        $$('#home-services-tabs').forEach((n) => new ServicesTabs(n).init());
    }

    if (bodyHasClass('single-post') || bodyHasClass('page')) {
        $$('#primary .author-and-post-info').forEach((container) => {
            container.querySelectorAll('.abh_box').forEach((n) => new AuthorBio(n).init());
        });
        initFreeArticleNotice();
    }

    $$('.posts-pagination').forEach((pag) => new ArchivePagination(pag).init());

    // how can the fool help you accordion
    $$('#secondary > .article-sidebar-widget')
        .slice(0, 1)
        .forEach((n) => {
            try {
                new SingleAccordion(n.querySelector('h3'), n.querySelector('.textwidget'), '(max-width: 842px)').init();
            } catch (e) {
                console.log('Could not create accordion');
                console.log(e.message);
            }
        });

    // run some code on a timeout to allow DOM to do stuff
    setTimeout(() => {
        if (bodyHasClass('no-megamenu')) {
            const header = document.querySelector('.site-header');
            if (header && header.childElementCount > 0) {
                nav.initMobileAccountButtons();
            }
        }

        new ScrollUpButton(document.querySelector('#scroll-up-btn')).init();

        initFoundation();
        initFlipClock();
        initSearch();
        initPagination();
        initEcap();
        new Tabs('(max-width: 767px)').init();
    }, 1000);

    const themeAssetUrl = (name) =>
        `${FOOL_GLOBALS.FOOL_FREESITE.parentThemeUrl}/assets/dist/${name}.js?ver=${FOOL_GLOBALS.FOOL_FREESITE.assetsVersions[name]}`;
    const addThemeAsyncJS = (name) => loadAsyncJs(themeAssetUrl(name));

    // called by quoteapi init function, so make it global
    // @ts-ignore: initFinancial is in window
    window.initFinancial = initFinancial;
    if (isTrue(FOOL_GLOBALS.FOOL_FREESITE.hasQuoteApi)) {
        addThemeAsyncJS('quoteapi');
    } else {
        initFinancial();
    }

    if ('FoolCriteo' in window) {
        // @ts-ignore: FoolCriteo is in window, see wp-criteo-php/views/snippet.php
        window.FoolCriteo.pushToGTM();
    }

    initCommerce();

    $$('.gpt-advert').forEach((el) =>
        up(el, '.widget').classList.add('googletag' in window ? 'advert-widget' : 'screen-reader-text'),
    );

    if (!document.querySelector('.wistia_responsive_wrapper')) {
        // remove custom inline styles
        $$('.single-sfrecap .entry-content [style]')
            // @ts-ignore: cannot easily cast to HTMLElement
            .filter((el) => el.getAttribute('class') && el.getAttribute('class').indexOf('wistia') === -1)
            // @ts-ignore: cannot easily cast to HTMLElement
            .filter((el) => el.style.display !== 'none')
            .forEach((el) => el.removeAttribute('style'));
    }

    if (isTrue(FOOL_GLOBALS.FOOL_FREESITE.isEmptyShell)) {
        document.body.classList.add('fouc-ready');
    }

    initEvergreen();

    // new foundation column style, support {size}-{n} type classes, e.g. large-6.
    $$('.row > .column, .row > .columns')
        .map((col) => col.parentElement)
        .filter((row) => row.children.length > 1)
        .filter((row) =>
            Array.from(row.children).every(
                (col) => col.classList.contains('columns') || col.classList.contains('column'),
            ),
        )
        .forEach((row) => row.classList.add('grid-x'));

    // update login button to redirect to current page
    // @ts-ignore: cannot easily cast to HTMLElement
    $$('.mega-header-login a').forEach(
        (a) => (a.href = `/wp-login.php?redirect_to=${encodeURIComponent(location.pathname)}`),
    );
});
